import { CircleLoader, Icon } from '@components/ui';
import { useApi } from '@data-access';
import { CookieHelper, GeneralHelper, MapperHelper } from '@helpers';
import { useOutsideAlerter } from '@hooks';
import clsx from 'clsx';
import React, { useRef, useState } from 'react';

import styles from './Export.module.scss';

export const Export = () => {
  const { api } = useApi();
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const exportRef = useRef(null);

  useOutsideAlerter(exportRef, setIsOpen.bind(null, false));

  const downloadJson = async () => {
    const response = await fetch(
      `${
        process.env.NODE_ENV === 'development' ? process.env.NEXT_PUBLIC_API_BASE_PATH : window.location.origin
      }/api/json_export`,
      { credentials: 'include', headers: { Authorization: `Bearer ${CookieHelper.get('access_token')}` } },
    );
    const raw = await response.blob();
    GeneralHelper.saveFile(raw, 'calvinJsonExport', 'application/json');
  };

  const downloadCsv = async () => {
    const response = await fetch(
      `${
        process.env.NODE_ENV === 'development' ? process.env.NEXT_PUBLIC_API_BASE_PATH : window.location.origin
      }/api/csv_export`,
      { credentials: 'include', headers: { Authorization: `Bearer ${CookieHelper.get('access_token')}` } },
    );
    const raw = await response.blob();
    GeneralHelper.saveFile(raw, 'calvinCsvExport', 'application/zip');
  };

  const handleDownload = async e => {
    e.preventDefault(); // Prevent the default link behavior
    setLoading(true); // Show loader

    try {
      const response = await fetch(`/cal/api/pdf-dashboard`);

      if (!response.ok) throw new Error('File download failed');

      const blob = await response.blob(); // Get the file as a blob
      const url = window.URL.createObjectURL(blob);

      // Create and trigger the <a> tag dynamically
      const link = document.createElement('a');
      link.href = url;
      link.download = `Dashboard report (${MapperHelper.formatDate(new Date())}).pdf`;
      document.body.appendChild(link);
      link.click();

      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      console.error('Download error:', error);
    } finally {
      setLoading(false); // Hide loader
    }
  };

  return (
    <div
      ref={exportRef}
      onClick={setIsOpen.bind(null, !isOpen)}
      className={styles.export}
    >
      {loading ? (
        <CircleLoader small />
      ) : (
        <div className={styles.label}>
          <span>Export</span>
          <Icon
            className={styles.icon}
            name="angle-right"
          />
        </div>
      )}
      <div className={clsx(styles.list, { [styles.isOpen]: isOpen })}>
        <a
          className={styles.item}
          onClick={handleDownload}
        >
          PDF report
        </a>

        <div
          onClick={downloadJson}
          className={styles.item}
        >
          JSON
        </div>
        <div
          onClick={downloadCsv}
          className={styles.item}
        >
          CSV
        </div>
        {/* <div
          onClick={downloadWordReport}
          className={styles.item}
        >
          Word report
        </div> */}
        {/* <div
          onClick={downloadExcelIndicators}
          className={styles.item}
        >
          Excel (indicators)
        </div>
        <div
          onClick={downloadExcelInventories}
          className={styles.item}
        >
          Excel (inventories)
        </div> */}
      </div>
    </div>
  );
};
